import { render } from "./PugAndTypescriptHelloWorld.vue?vue&type=template&id=26ee267e&lang=pug"
import script from "./PugAndTypescriptHelloWorld.vue?vue&type=script&setup=true&lang=ts"
export * from "./PugAndTypescriptHelloWorld.vue?vue&type=script&setup=true&lang=ts"
script.render = render

export default script